const E=["DATE_RANGE","SINGLE_DATE"];export{E as AllCalendarTypes};
//# sourceMappingURL=CalendarSnippet.types.js.map
